import React, { useState } from 'react';

import {
    Text,
    Container,
    Row,
    Col,
    className,
    Heading,
    ImageComponent,
} from 'aplazame-design-system';

import style from './style.module.scss';
import textStyle from 'aplazame-design-system/src/scss/text.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';

const bgColors = [
    colorStyle['bg--primary'],
    colorStyle['bg--secondary'],
    colorStyle['bg--tertiary'],
    colorStyle['bg--fourth'],
];

function getRandomBgClassname() {
    let key = Math.floor(Math.random() * 3);
    return bgColors[key];
}

function Person({ image, name, personPosition }) {
    const [bgClassName] = useState(getRandomBgClassname());

    return (
        <div {...className('text-center', style.wrapper)}>
            {image && image.file ? (
                <ImageComponent image={image} aspectRatio={0.85} />
            ) : (
                <div
                    {...className(
                        `${style['image-placeholder']} ${bgClassName}`
                    )}
                />
            )}
            <Text
                tag="span"
                className={`body font-weight-bold ${style.name}`}
                mt={{ xs: 2, lg: 3 }}
                mb={{ xs: 1, lg: 0 }}
            >
                {name}
            </Text>
            {personPosition ? (
                <Text tag="span" className={`body d-inline-block`}>
                    {personPosition}
                </Text>
            ) : null}
        </div>
    );
}

export default function TeamSection({ title, titleTag, executiveTeam, team, id }) {
    return (
        <section aria-labelledby={id}>
            <Container pt={{ xs: 10 }} pb={{ xs: 5, lg: 10 }}>
                <Row>
                    <Col>
                        <Heading
                            id={id}
                            tag={titleTag}
                            className={`h1 ${textStyle.gradual} text-center`}
                            mb={{ xs: 10, lg: 12 }}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {title}
                        </Heading>
                    </Col>
                </Row>
                <Row>
                    {executiveTeam && executiveTeam.length
                        ? executiveTeam.map((person, i) => (
                            <Col
                                key={i}
                                col={{
                                    xs: 6,
                                    md: 4,
                                    lg: 3,
                                }}
                                pb={{
                                    xs: 5,
                                    lg: 6,
                                }}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                                data-sal-delay={`xs-${i % 2 ? '100' : 'none'
                                    }--lg-${(i % 4) * 100}`}
                            >
                                <Person {...person} />
                            </Col>
                        ))
                        : null}
                    <Col pb={{ xs: 4, lg: 7 }}>
                        <hr className={style.separator} />
                    </Col>
                    {team && team.length
                        ? team.map((person, i) => (
                            <Col
                                key={i}
                                col={{
                                    xs: 6,
                                    lg: 3,
                                }}
                                pb={{
                                    xs: 5,
                                    lg: 6,
                                }}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                                data-sal-delay={`xs-${i % 2 ? '100' : 'none'
                                    }--lg-${(i % 4) * 100}`}
                            >
                                <Person {...person} />
                            </Col>
                        ))
                        : null}
                </Row>
            </Container>
        </section>
    );
}
